import React from "react";
import PropTypes from "prop-types";
import { formatAndShortenMoney } from "../../../../utils/common";
import "../CompoundSlider.scss";

export class Handle extends React.Component {
  static propTypes = {
    handle: PropTypes.shape({
      id: PropTypes.string,
      percent: PropTypes.number,
      value: PropTypes.number,
    }),
    getHandleProps: PropTypes.func,
  };

  render() {
    const { getHandleProps, handle } = this.props;
    const { id, percent, value } = handle;

    return (
      <div
        className="handleStyle"
        style={{
          left: `${percent}%`,
        }}
        {...getHandleProps(id)}
      >
        <div className="handleValues">{formatAndShortenMoney(value)}</div>
      </div>
    );
  }
}

export default Handle;
